import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import Loading from 'quasar/src/plugins/Loading'

Loading.setDefaults({
  spinner: QSpinnerGears,
  spinnerColor: 'white',
  spinnerSize: 50,
})
